import { render, staticRenderFns } from "./ConstructorLayout.vue?vue&type=template&id=5b13c977&"
import script from "./ConstructorLayout.vue?vue&type=script&lang=js&"
export * from "./ConstructorLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports